<template>
  <div class="container">
    <div class="wrap">
      <div class="box-con box-con-info z-flex z-flex-between">
        <div class="img-wrap">
          <el-image class="img" fit="cover" :src="img"></el-image>
          <span :class="['sta',sta==1?'sta-ing':'']">{{sta==1?'报名中':'已截止'}}</span>
        </div>
        <div class="info-wrap">
          <div class="title">
            <el-tag size="small" effect="dark">{{tag}}</el-tag>
            {{title}}
          </div>
          <div class="price-con">
            <div class="info-item z-flex">
              <div class="info-item-l">集合时间：</div>
              <div class="info-item-r">{{gatherTime}}</div>
            </div>
            <div class="info-item z-flex">
              <div class="info-item-l">集合地点：</div>
              <div class="info-item-r">{{gatherPlace}}</div>
            </div>
            <div class="z-flex z-flex-between">
              <div class="info-item z-flex price-item">
                <div class="info-item-l">会员价格：</div>
                <div class="info-item-r">
                  <span>￥</span>
                  <span class="price">{{price}}</span>起
                </div>
              </div>
              <div class="btn-group z-flex">
                <el-button class="btn" type="primary" :disabled="sta==2" @click="toJoin">{{sta==1?'我要报名':'活动已截止'}}</el-button>
              </div>
            </div>
          </div>
          <div class="info-item z-flex">
            <div class="info-item-l">创作时间：</div>
            <div class="info-item-r">{{date}}</div>
          </div>
          <div class="info-item z-flex">
            <div class="info-item-l">报名截止：</div>
            <div class="info-item-r">{{deadline}}</div>
          </div>
          <div class="info-item z-flex teachers-item">
            <div class="info-item-l">指导老师：</div>
            <div class="info-item-r z-flex">
              <el-tag v-for="(item,index) in teachers" :key="index" size="small">{{item}}</el-tag>
            </div>
          </div>
          <div class="info-bottom z-flex z-flex-between">
            <div class="info-item z-flex">
              <div class="info-item-l">备&emsp;&emsp;注：</div>
              <div class="info-item-r">{{remarks}}</div>
            </div>
            <div class="share z-flex">分享至：<i class="iconfont icon-weixin"></i></div>
          </div>
        </div>
      </div>
      <div class="box-con-wrap z-flex z-flex-between">
        <div class="box-con box-con-main">
          <div class="hd z-flex"><span>线路详情</span></div>
          <div class="detail" v-html="detail"></div>
          <div class="detail-bottom z-flex z-flex-center">
            <el-button class="btn-collect btn-iscollect" type="primary" v-if="isCollect" @click="collect">
              <i class="iconfont icon-yishoucang"></i>
              <span>已收藏</span>
            </el-button>
            <el-button class="btn-collect" type="primary" v-else @click="collect">
              <i class="iconfont icon-shoucang"></i>
              <span>收藏</span>
            </el-button>
            <el-button class="btn-share" type="primary" @click="share">
              <i class="iconfont icon-zhuanfa"></i>
              <span>分享</span>
            </el-button>
          </div>
        </div>
        <!-- 采风推荐 -->
        <recoCaifeng></recoCaifeng>
      </div>
    </div>
  </div>
</template>

<script>
import recoCaifeng from "@/components/recoCom/recoCaifeng"
export default {
  components: {
    recoCaifeng,
  },
  data() {
    return {
      id: 0,
      isCollect:false,
      img:'',
      title:'',
      tag:'',
      date:'',
      deadline:'',
      teachers:[],
      price:'',
      gatherTime:'',
      gatherPlace:'',
      sta:1,//0--报名中;1--已截止
      remarks:'',
      detail:``
    };
  },
  computed: {
    
  },
  mounted() {
    this.id = this.$route.query.id;
    this.$axios.api.caifengDetail({id: this.id}, (res) => {
      if (res.code == 200) {
        this.isCollect = res.data.is_collect ? true : false;
        this.sta = res.data.sta;
        this.title = res.data.title;
        this.detail = res.data.desc;
        this.img = res.data.img;
        this.date = res.data.sign_date;
        this.price = res.data.price;
        this.tag = res.data.line;
        this.deadline = res.data.end_time;
        this.teachers = res.data.teacher;
        this.gatherTime = res.data.collect_time;
        this.gatherPlace = res.data.collect_site;
        this.remarks = res.data.remark;
        this.isCollect = is_collect == 1?true:false;
      }
    });
  },
  methods: {
    toUrl(url){
      this.$router.push({
        path:url,
      })
    },
    collect(){
      let status = this.isCollect?0:1;
      this.$axios.api.request({
        url: "/api/qtclub/user/collectSubmit",
        data: {
          object: 'caifeng',
          object_id: this.id,
          status: status,
        }
      }, (res) => {
        if(res.data.status == 1){
          this.isCollect = true;
          return this.$message.success('收藏成功！');
        }else{
          this.isCollect = false;
          return this.$message.error('取消收藏');
        }
      })
    },
    //报名
    toJoin(){
      return this.$parent.clickToPay({
        platform: 'caifeng',
        combo_id: this.id,
        recharge_type: 9,
        price: this.price,
      });
    },
    share(){

    }
  },
};
</script>

<style lang="scss" scoped>
.box-con-wrap{
  align-items: flex-start;
}
.box-con-main{
  width:1050px;
  .hd{
    font-size: 18px;
    height: 50px;
    border-bottom: 1px solid #e2e2e2;
    padding: 0 20px;
    span{
      display: inline-block;
      line-height: 49px;
      border-bottom: 2px solid $colorMain;
    }
  }
  .detail{
    padding:20px;
    ::v-deep p{
      margin:10px 0;
    }
    ::v-deep img{
      max-width:100%;
    }
  }
  .detail-bottom{
    padding:30px 0;
    margin:0 20px;
    border-top:$borderDashed;
    .el-button{
      padding:0 20px;
      height:40px;
      .iconfont{
        margin-right: 6px;
      }
    }
    .btn-iscollect{
      background:#a2a2a2;
      border-color: #a2a2a2;
    }
  }
}
.box-con-info{
  padding: 20px;
  margin-bottom: 20px;
  align-items: flex-start;
  .img-wrap{
    width:600px;
    height:300px;
    border-radius: 4px;
    overflow: hidden;
    position: relative;
    .img{
      width:100%;
      height:100%;
      object-fit: cover;
    }
    .sta{
      position: absolute;
      left: 0;
      top: 0;
      font-size: 13px;
      color: #fff;
      background:$colorGreyDark;
      padding: 5px 10px;
      border-bottom-right-radius: 4px;
      &.sta-ing{
        background:$colorGreen;
      }
    }
  }
  .info-wrap{
    width:calc(100% - 620px);
    color: #777;
    font-size: 14px;
    .title{
      font-size: 18px;
      font-weight: 700;
      vertical-align: middle;
      @include textOverflowNum(2);
      margin-bottom: 15px;
      color: #333;
      vertical-align: middle;
      .el-tag{
        font-weight: normal;
        margin-right: 5px;
      }
    }
    .info-item{
      margin: 10px;
      .info-item-l{
        width:80px;
      }
      .info-item-r{
        flex: 1;
      }
    }
    .teachers-item{
      .info-item-r{
        margin-bottom: -10px;
      }
      .el-tag{
        margin: 0 10px 10px 0;
      }
    }
    .price-con{
      background:$colorBg;
      padding:5px 0;
      .price-item{
        align-items: flex-end;
        .info-item-r{
          margin-bottom: -4px;
          span{
            color:$colorMain;
          }
          .price{
            font-size:32px;
            font-weight: 700;
            font-family: Arial, Helvetica, sans-serif;
            margin-right: 10px;
          }
        }
      }
      .btn-group{
        margin-right: 10px;
        .btn{
          padding: 12px 30px;
        }
      }
    }
    .info-bottom{
      border-top: $borderDotted;
      .info-item{
        flex: 1;
      }
      .share{
        .icon-weixin{
          font-size: 30px;
          cursor: pointer;
          color: $colorGreen;
        }
      }
    }
  }
}
</style>
